import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MeetingChapterDto } from '@interfaces/meetings/responses/meeting-insights.response';
import { formatarMarcaDeTempo } from '@features/dashboard/meetings/components/meeting-presenter';

/**
 * Faixa de capítulos embaixo do vídeo: "04:10 Condições da linha 4131", com o resumo curto do
 * capítulo no título do botão. Clicar leva o vídeo ao ponto (e a transcrição acompanha).
 *
 * Os capítulos vêm do agente de resumo do Cog (PBI 3225, task 3228). Enquanto ele roda, a faixa diz
 * que está preparando; sem capítulo nenhum depois de pronto, diz que a reunião não teve divisão.
 */
@Component({
  selector: 'app-meeting-chapters',
  standalone: true,
  templateUrl: './meeting-chapters.component.html',
  styleUrl: './meeting-chapters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingChaptersComponent {
  readonly capitulos = input<MeetingChapterDto[] | null>(null);
  readonly temVideo = input(false);
  /** Os agentes do Cog ainda estão rodando. */
  readonly processando = input(false);
  /** O resumo terminou (pronto ou com falha): lista vazia quer dizer que não há capítulos. */
  readonly semCapitulos = input(false);

  readonly irPara = output<number>();

  protected readonly itens = computed(() =>
    [...(this.capitulos() ?? [])]
      .sort((a, b) => a.startSeconds - b.startSeconds)
      .map(c => ({
        ...c,
        tempo: formatarMarcaDeTempo(c.startSeconds),
        dica: c.summary
          ? `${c.title}: ${c.summary}`
          : `Ir para ${formatarMarcaDeTempo(c.startSeconds)}`,
      }))
  );
}
